// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__YvXb0","load":"skeleton_load__EU7Gg"};